module.exports = __webpack_public_path__ + "static/media/bike3.c83f8672.jpg";